module.exports = "./img/desktop_logo.961d042.png";